import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { useTranslation } from 'react-i18next';
import ImageFluid from '../components/imageFluid';


const Cooling = () => {
  const { t } = useTranslation();
  
  return(
    <Layout>
      <SEO title={t('COOLING_SEO_TITLE')} description={t('COOLING_SEO_DESCRIPTION')} />
      <div className="primary-img__container">
          <ImageFluid queryName="coolingHead" alt="Solar Cooling" />
          <h1>{t('COOLING_HEAD-H1')}</h1>
      </div>
      <div className="main__container">
        <section>
          <p>{t('COOLING_MAIN-P1')}</p>
          <p>{t('COOLING_MAIN-P2')}</p>
          <p>{t('COOLING_MAIN-P3')}</p>
          <p>{t('COOLING_MAIN-P4')}</p>
          <div className="secondary-img">
              <ImageFluid queryName="coolingSecondary" alt="Solar Cooling" />
            </div>
          <p>{t('COOLING_MAIN-P5')}</p>
          <p>{t('COOLING_MAIN-P6')}</p>
        </section>
      </div>
    </Layout>
  )

}

export default Cooling
